import PropTypes from 'prop-types';
import React, { useContext, useRef, useState } from 'react';
import NavBar from './NavBar';
import Breadcrumb from './Breadcrumb';
import useOutsideClick from '../../hooks/useOutsideClick';
import { ConfigContext } from '../../contexts/ConfigContext';
import * as actionType from '../../store/actions';

const AdminLayout = ({ children }) => {
  const [urlValue, setUrlValue] = useState('');
  const ref = useRef();
  const { state: { collapseMenu }, dispatch } = useContext(ConfigContext);

  // const paddingValue = urlValue === "dashboard" ? '' : '30px';

  const handleCollapseMenu = () => dispatch({ type: actionType.COLLAPSE_MENU });

  useOutsideClick(ref, () => {
    if (collapseMenu) handleCollapseMenu();
  });

  const renderMainContainer = () => (
      <div className="pcoded-main-container">
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <Breadcrumb currentURLFunction={setUrlValue} />
              {children}
            </div>
          </div>
        </div>
      </div>
  );

  const renderCommonComponent = () => (
      <React.Fragment>
        <NavBar />
      </React.Fragment>
  );

  return (
      <React.Fragment>
        {renderCommonComponent()}
        {renderMainContainer()}
      </React.Fragment>
  );
};

AdminLayout.propTypes = {
  children: PropTypes.node,
};

export default AdminLayout;